import { Injectable } from "@angular/core";
declare var $: any;

@Injectable()
export class GridService {
    globalRowList: number[] = [50, 200, 500, 1000, 2000, 5000, 10000];

    constructor() {

    }

    public loadGrid(data: any): any {
        //if (data.hoverrows !== false)
        //    data.hoverrows = true;
        var context = this;
        var grid = $("#" + data.id).jqGrid({
            // url: "http://trirand.com/blog/phpjqgrid/examples/jsonp/getjsonp.php?callback=?&qwery=longorders",
            // mtype: "GET",
            datatype: "local",
            data: data.data,
            colModel: data.colModel,
            //page: data.page,
            scroll: 1,
            // scrollPopUp: true,
            shrinkToFit: false,
            scrollrows: true,
            viewrecords: true,
            gridview: true,
            loadonce: true,
            ignoreCase: true,
            sortname: "OrderID",
            width: data.width,
            height: data.height,
            // scrollOffset: 0,
            //rowNum: this.globalRowList[0],
            //pager: data.pager,
            rowTotal: 5000,
            //rowList: this.globalRowList,
            caption: " ",
            //hoverrows: data.hoverrows,
            hidegrid: false,
            // rownumbers: true,
            multiselect: data.multiSelect,
            recreateFilter: true,
            // rownumWidth: 20,
            // rownumbers: true,
            sortable: true,
            //prmNames: { npage: "npage" },
            //grouping: true,
            //groupingView: {
            //    // groupField: ["ProductID"],
            //    groupColumnShow: [true],
            //    groupText: ["<b>{0}</b> ({1})"],
            //    // groupOrder: ["asc"],
            //    groupSummary: [true],
            //    groupCollapse: true
            //}
            //},
            //gridComplete: function () {
            //    var rows = $("#eventGrid").getDataIDs();
            //    var yesterdayDate = new Date();
            //    yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            //    yesterdayDate = getFormattedDate(yesterdayDate);

            //    for (var i = 0; i < rows.length; i++) {
            //        var eventEndDateString = $("#eventGrid").getCell(rows[i], "EventEndTime"); //get event end timestamp

            //        //only color events that have end time within the last 24 hours
            //        if (eventEndDateString >= yesterdayDate /*"2016-06-28 09:41:02 AM"*/) {
            //            $("#eventGrid").jqGrid('setRowData', rows[i], false, { color: 'white', weightfont: 'bold', background: 'green' });
            //        }
            //    }
            //}
        });
        return grid;

    }

    // In the events parameter, parentComponent must have a function of the same name
    // This allows for generic, grid-side behavior to be handled here, with more specific 
    // behavior in the component that should deal with it
    setGridEvents(events, parentComponent): void {
        var gridEvents: any = {};
        var grid: any = parentComponent.grid;
        for (var event of events) {
            switch (event) {
                case "selectRow": gridEvents["beforeSelectRow"] = function (id, e) {
                    var index = grid[0].p._index;
                    var data = grid.jqGrid("getGridParam", "data");
                    parentComponent.selectRow(data[index[id]], e);
                }; break;
                case "noSelect": gridEvents["beforeSelectRow"] = function (id, e) {
                    return false;
                };
                gridEvents["onRightClickRow"] = function (rowid, iRow, iCol, e) {
                    grid.jqGrid('resetSelection');
                    return false;
                }; break;
                case "editSelect": gridEvents["onCellSelect"] = function (rowId, iCol, cellcontent, e) {
                    if (this.id == "routing-grid" && $("#gbox_" + this.id).find("tr.ui-jqgrid-labels").children()[iCol].id == this.id + "_teamName") {
                        var index = grid[0].p._index;
                        var data = grid.jqGrid("getGridParam", "data");
                        var row = grid.find("tbody").find("#" + rowId);
                        var teamName;
                        teamName = grid.find(".grid-select").val()
                        grid.find(".grid-select").parent().html(teamName);
                        parentComponent.selectCell(data[index[rowId]], row.children()[iCol], row, e);
                        return false;
                    }
                    else if (this.id == "barriers-grid" && $("#gbox_" + this.id).find("tr.ui-jqgrid-labels").children()[iCol].id == this.id + "_description") {
                        var index = grid[0].p._index;
                        var data = grid.jqGrid("getGridParam", "data");
                        var row = grid.find("tbody").find("#" + rowId);
                        var description;
                        description = grid.find(".grid-text-input").val()
                        grid.find(".grid-text-input").parent().html(description);
                        parentComponent.selectCell(data[index[rowId]], row.children()[iCol], row, e);
                        return false;
                    }
                }; break;
                case "loadComplete": {
                    var oldFrom = $.jgrid.from,
                        lastSelected;

                    $.jgrid.from = function (source, initalQuery) {
                        var result = oldFrom.call(this, source, initalQuery),
                            old_select = result.select;
                        result.select = function (f) {
                            lastSelected = old_select.call(this, f);
                            return lastSelected;
                        };
                        return result;
                    };

                    if (grid.jqGrid("getGridParam", "multiselect"))
                        gridEvents["gridComplete"] = function () {
                            $("#" + this.id).jqGrid('hideCol', 'cb')
                        }

                    gridEvents["loadComplete"] = function () {
                        if (parentComponent.scrolling) {
                            parentComponent.scrollPosition.y = this.grid.bDiv.scrollTop;
                            parentComponent.scrollPosition.x = this.grid.bDiv.scrollLeft;
                        }
                        parentComponent.scrolling = true;
                        if ($(this).jqGrid('getGridParam', 'reccount') == 0) {
                            $(this).find(".jqgfirstrow").css("height", "1px");
                        }
                        else {
                            $(this).find(".jqgfirstrow").css("height", "0px");
                        }
                        this.p.lastSelected = lastSelected;
                        var pageNum = grid.jqGrid("getGridParam", "page");
                        var pageSize = grid.jqGrid("getGridParam", "rowNum");
                        var pageData = grid.jqGrid("getGridParam", "lastSelected");
                        var end = pageSize * pageNum;
                        if (end > pageData.length)
                            end = pageData.length;
                        for (var i = pageSize * (pageNum - 1); i < end; i++) {
                            if (pageData[i].cb == true)
                                grid.jqGrid("setSelection", pageData[i].id, false);
                        }

                        this.grid.bDiv.scrollTop = parentComponent.scrollPosition.y;
                        this.grid.bDiv.scrollLeft = parentComponent.scrollPosition.x;
                        if(parentComponent.loadComplete)
                            parentComponent.loadComplete();
                    }
                }; break;
                case "sortColumn": gridEvents["onSortCol"] = function (index, columnIndex, sortOrder) {
                    //parentComponent.scrollPosition.y = this.grid.bDiv.scrollTop;
                    //parentComponent.scrollPosition.x = this.grid.bDiv.scrollLeft;
                    //parentComponent.scrolling = false;
                }
            } 
        }
        parentComponent.grid.jqGrid("setGridParam", gridEvents);
    }

    getColumnIndexByName(grid: any, columnName: string): number {
        var cm = $(grid).jqGrid('getGridParam', 'colModel'), i, l = cm.length;
        for (i = 0; i < l; i += 1) {
            if (cm[i].name === columnName) {
                return i; // return the index
            }
        }
        return -1;
    }

    modifySearchingFilter(grid: any, separator: string) {
        var i, l, rules, rule, parts, j, group, str, iCol, cmi, cm = grid.p.colModel,
            filters = $.parseJSON(grid.p.postData.filters);
        if (filters && filters.rules !== undefined && filters.rules.length > 0) {
            rules = filters.rules;
            for (i = 0; i < rules.length; i++) {
                rule = rules[i];
                iCol = this.getColumnIndexByName(grid, rule.field);
                cmi = cm[iCol];
                if (iCol >= 0 &&
                    ((cmi.searchoptions === undefined || cmi.searchoptions.sopt === undefined)
                        && (rule.op === "eq")) ||
                    (typeof (cmi.searchoptions) === "object" &&
                        $.isArray(cmi.searchoptions.sopt) &&
                        cmi.searchoptions.sopt[0] === rule.op)) {
                    // make modifications only for the 'contains' operation
                    parts = rule.data.split(separator);
                    if (parts.length > 1) {
                        if (filters.groups === undefined) {
                            filters.groups = [];
                        }
                        group = {
                            groupOp: 'OR',
                            groups: [],
                            rules: []
                        };
                        filters.groups.push(group);
                        for (j = 0, l = parts.length; j < l; j++) {
                            str = parts[j];
                            if (str) {
                                // skip empty '', which exist in case of two separaters of once
                                group.rules.push({
                                    data: parts[j],
                                    op: rule.op,
                                    field: rule.field
                                });
                            }
                        }
                        rules.splice(i, 1);
                        i--; // to skip i++
                    }
                }
            }
            grid.p.postData.filters = JSON.stringify(filters);
        }
    }

    gridResize(grid: any, string: string): void {
        grid.jqGrid("gridResize", {
            handles: "n",
            // containment: ".grid", 
            minHeight: 99,
            maxHeight: $("#wrapper2").height() - 51 - $(".footer-container").height() + 1,
            // alsoResize: "#gridcontainer",
            stop: function (event, ui) {
                /*$(".ui-jqgrid-bdiv").css("height", $("#gbox_" + string).height() - 109);
                */
                //$("#grid-pager").css("bottom", 0);
                var h = ui.size.height;
                $("#gbox_" + string).css("height", h);
            },
            resize: function (event, ui) {
                var h = ui.size.height;
                // $(".ui-jqgrid-bdiv").css("height", $(".ui-jqgrid-bdiv").height() + 200);
                //$("#grid-pager").css("position", "relative");
                $("#gridcontainer").css("height", h + $("#navbar").outerHeight() - 2 + $(".footer-container").height() - 1);
                $(".grid-main").css("height", h);
                $("." + string).css("height", h);
                $("#gbox_" + string).css("top", 0);
                /*$("#gview_" + string).css("position", "absolute");
                $("#gview_" + string).css("top", 0);
                $("#gview_" + string).css("bottom", 0);
                $("#grid-pager").css("position", "absolute");
                $("#grid-pager").css("bottom", 0);
                $("#gbox_" + string).css("top", -2);
                $(".ui-jqgrid-bdiv").css("height", $("#gbox_" + string).height() - 109);
                */
                // $("#gview_grid").css("bottom", 28);
                // $("gbox_grid").css("height", $("#gview_grid").height() + 28)
                // $("#gridcontainer").css("height", $("#gbox_grid").height() + 40 + 50);
                // $("#grid").setGridHeight(ui.size.height);
                /* $("#gridcontainer").css("height", $("#gbox_grid").height() + 50 + 40 + 28);
                 $("#grid").setGridWidth($(window).width(), false);
                // $("#gbox_grid").css("bottom", 28);*/
            }
        });
    }

    filterToolbar(grid: any, alerts: any, evt: any, services: any, gridData: any, gridInfo: any): void {
        grid.jqGrid("filterToolbar", {
            stringResult: true,
            enableClear: true,
            searchOperators: true,
            beforeSearch: function () {
                //gridInfo.scrollPosition = { x: this.grid.bDiv.scrollLeft, y: this.grid.bDiv.scrollTop };
                // tempData = $("#grid").jqGrid("getGridParam", "lastSelected");
                /* if(tempData.length > 15)
                     $("#grid").jqGrid("setGridHeight", 15*26);
                 else 
                     $("#grid").jqGrid("setGridHeight", tempData.length*26);*/
                //services.gridService.modifySearchingFilter(this, ',');
                return true;
            },
            afterSearch: function (data) {
                var filters = JSON.parse(grid.jqGrid("getGridParam", "postData").filters);
                if (filters.rules.length > 0)
                    gridData.highlight[gridData.selectedTabIndex] = true;
                else
                    gridData.highlight[gridData.selectedTabIndex] = false;

                     


                
                gridInfo.scrollPosition.y = this.grid.bDiv.scrollTop;
                gridInfo.scrollPosition.x = this.grid.bDiv.scrollLeft;
                var tempData = services.gridService.filterData(filters, alerts.array, grid);
                services.clientDataService.updateData({ data: evt.data, grid: grid }, { data: tempData, grid: grid }, evt.event);
                this.grid.bDiv.scrollTop = gridInfo.scrollPosition.y;
                this.grid.bDiv.scrollLeft = gridInfo.scrollPosition.x;
                //services.gridService.changeGridData(tempData, grid.jqGrid("getGridParam", "colModel"), grid);
                // mapService.selectedLayer.getSource().clear();
                // $scope.idsOfSelectedRows.length = 0;
                // tempData = $("#grid").jqGrid("getGridParam", "data");
                // mapService.reInitData(tempData);
                // mapService.reselectPoints(tempData, $scope.idsOfSelectedRows, $("#grid")[0].p._index);
                // mapService.bindGridData($("#grid").jqGrid("getGridParam", "lastSelected"), mapService.obj);
                // $("#gbox_grid").css("top", 50);

            }
        });
        /*$.jgrid.extend.search.groupOps[0].text = "AND"
        $.jgrid.search.groupOps[1].text = "OR"
        grid.jqGrid("searchGrid", {
            multipleSearch: true,
            modal: true,

        });*/
    }

    pager(grid: any, string: string, gridData: any, gridInfo: any, toolbar: boolean): void {
        $("tr.ui-jqgrid-labels").sortable({
            distance: 20
        })
        grid.jqGrid("navGrid", "#" + string + "-pager", {
            search: false,
            add: false,
            edit: false,
            del: false,
            refresh: false,
            view: false,
            align: "left",
            afterRefresh: function () {
                grid[0].triggerToolbar();
            }
        },
        {},
        {},
        {},
        {
            multipleSearch: true,
            recreateFilter: true
        },
        {}
        );
        grid.jqGrid("navGrid", "#" + string + "-pager", { add: false, edit: false, del: false });
        // on chang select value change grouping
        /*$("#chngroup").change(function () {
            var vl = $(this).val();
            if (vl) {
                if (vl === "clear") {
                    $("#grid").jqGrid("groupingRemove", true);
                } else {
                    $("#grid").jqGrid("groupingGroupBy", vl);
                }
            }
        });*/
        if (toolbar) {
            grid.jqGrid("navButtonAdd", "#" + string + "-pager", {
                caption: ""/*"Show"*/, buttonicon: "ui-icon-toggle-on", title: "Toggle Filter Toolbar",
                id: string + "-toggle-btn",
                onClickButton: function () {
                    var h = 31;
                    if (!gridInfo.toolbarToggled) {
                        h = -h;
                    }
                    grid[0].toggleToolbar();
                    gridInfo.toolbarToggled = !gridInfo.toolbarToggled;
                    // $("#gview_" + gridInfo.gridString).css("height", $("#gview_" + gridInfo.gridString).height() + h);
                    var body = $("#gview_" + gridInfo.gridString).find(".ui-jqgrid-bdiv")
                    var angle = 0;
                    if (!gridInfo.toolbarToggled)
                        angle = 180;
                    body.css("height", body.height() + h);
                    $("#" + string + "-toggle-btn").css({
                        '-webkit-transform': 'rotate(' + angle + 'deg)',
                        '-moz-transform': 'rotate(' + angle + 'deg)',
                        '-ms-transform': 'rotate(' + angle + 'deg)',
                        '-o-transform': 'rotate(' + angle + 'deg)',
                        'transform': 'rotate(' + angle + 'deg)'
                    });
                    //window.location = grid.jqGrid("getCell", rowid, "dataUrl");
                }
            });
        }
    }

    filterData(filterData: any, data: any[], grid: any) {
        var rules = filterData.rules;
        var array = data;
        let array2 = [];
        for (var i = 0; i < rules.length; i++) {
            var filterOr = rules[i].data.split(",");
            array = array.filter(function (currentValue) {
                var temp = currentValue[rules[i].field];
                for (var filter of filterOr) {
                    if (rules[i].op == 'ge') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) >= Date.parse(filter)) {
                                return true;
                            }
                        }
                        else if (temp >= filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'gt') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) >= Date.parse(filter) + 86400000) {
                                return true;
                            }
                        }
                        else if (temp > filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'le') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) < Date.parse(filter) + 86400000) {
                                return true;
                            }
                        }
                        else if (temp <= filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'lt') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) < Date.parse(filter)) {
                                return true;
                            }
                        }
                        else if (temp < filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'eq') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) >= Date.parse(filter) && Date.parse(temp) < Date.parse(filter) + 86400000) {
                                return true;
                            }
                        }
                        else if (temp == filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'ne') {
                        if (rules[i].field.toLowerCase() == "timestamp") {
                            if (Date.parse(temp) < Date.parse(filter) && Date.parse(temp) >= Date.parse(filter) + 86400000) {
                                return true;
                            }
                        }
                        else if (temp != filter) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'bw') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) == 0) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'bn') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) != 0) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'in') {
                        if (String(filter).toUpperCase().indexOf(String(temp).toUpperCase()) >= 0) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'ni') {
                        if (String(filter).toUpperCase().indexOf(String(temp).toUpperCase()) < 0) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'ew') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) == String(temp).length - String(filter).length) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'en') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) != String(temp).length - String(filter).length) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'cn') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) >= 0) {
                            return true;
                        }
                    }
                    else if (rules[i].op == 'nc') {
                        if (String(temp).toUpperCase().indexOf(String(filter).toUpperCase()) < 0) {
                            return true;
                        }
                    }
                }

            });
            if (filterData.groupOp == "OR") {
                array2 = this.concatenate(array, array2);
                array = data;
            }
        }
        if (filterData.groupOp == "AND")
            array2 = array;
        return array2;
        //var rules = filterData.rules;
        //var array = data;
        //var array3 = [];
        //for (var i = 0; i < rules.length; i++) {
        //    var filterOr = rules[i].data.split(",");
        //    var array2 = [];
        //    var count = 0;
        //    if (rules[i].field.toLowerCase().includes("unixtimems"))
        //        rules[i].data = Date.parse(rules[i].data);
        //    for (var j = 0; j < array.length; j++) { //"ge", "le", "eq", "gt", "lt", "ne", "bw", 'bn', 'in', 'ni', 'ew', 'en', 'cn', 'nc'
        //        var temp = array[j][rules[i].field];
        //        if (rules[i].op == 'ge')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) >= Date.parse(rules[i].data))
        //                    array2.push(array[j]);
        //            }
        //            else if (temp >= rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'gt')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) >= Date.parse(rules[i].data) + 86400000)
        //                    array2.push(array[j]);
        //            }
        //            else if (temp > rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'le')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) < Date.parse(rules[i].data) + 86400000)
        //                    array2.push(array[j]);
        //            }
        //            else if (temp <= rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'lt')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) < Date.parse(rules[i].data))
        //                    array2.push(array[j]);
        //            }
        //            else if (temp < rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'eq')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) >= Date.parse(rules[i].data) && Date.parse(temp) < Date.parse(rules[i].data) + 86400000)
        //                    array2.push(array[j]);
        //            }
        //            else if (temp == rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'ne')
        //            if (rules[i].field.toLowerCase() == "timestamp") {
        //                if (Date.parse(temp) < Date.parse(rules[i].data) && Date.parse(temp) >= Date.parse(rules[i].data) + 86400000)
        //                    array2.push(array[j]);
        //            }
        //            else if (temp != rules[i].data)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'bw')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) == 0)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'bn')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) != 0)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'in')
        //            if (String(rules[i].data).toUpperCase().indexOf(String(temp).toUpperCase()) >= 0)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'ni')
        //            if (String(rules[i].data).toUpperCase().indexOf(String(temp).toUpperCase()) < 0)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'ew')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) == String(temp).length - String(rules[i].data).length)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'en')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) != String(temp).length - String(rules[i].data).length)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'cn')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) >= 0)
        //                array2.push(array[j]);
        //        if (rules[i].op == 'nc')
        //            if (String(temp).toUpperCase().indexOf(String(rules[i].data).toUpperCase()) < 0)
        //                array2.push(array[j]);
        //    }
        //    if (filterData.groupOp == "AND") {
        //        //if (i == rules.length - 1 && filterData.groups && filterData.groups.length > 0)
        //        //    array2 = this.filterData(filterData.groups[0], array2, grid);
        //        array = array2;
        //        array3 = array2;
        //    }
        //    else if (filterData.groupOp == "OR") {
        //        array = data;
        //        this.clientDataService.concatenate(array3, array2);
        //    }
        //}
        ////vm.changeGrid(array, grid.jqGrid("getGridParam", "colModel"), grid);
        //if(rules.length > 0)
        //    array = array3;
        //return array;
    }

    concatenate(array1: any[], array2: any[]): any[] {
        let concatArray = [];
        let arrayLookup = {};
        for (let obj of array1) {
            arrayLookup[obj.id] = obj;
        }
        for (let obj of array2) {
            arrayLookup[obj.id] = obj;
        }
        for (let key in arrayLookup) {
            concatArray.push(arrayLookup[key]);
        }
        return concatArray;
    }

    makeGridSortable(gridData: any, string: string) {
        $("#cb_" + string).hide();
        $("#jqgh_" + string + "_cb").click(function (e) {
            if (e.target == this)
                $("#" + string).jqGrid("sortGrid", "cb", true, "desc");
        })
        var cbColModel = $("#" + string).jqGrid('getColProp', 'cb');
        cbColModel.sortable = true;
        cbColModel.sorttype = function (value, item) {
            return 'cb' in item && item.cb ? 1 : 0;
        };
    }

    //selectAll(gridData, allSelected, type) {
    //    $("#cb_" + gridData.gridData.alerts.gridString).click();
    //    var selRowIds = $("#adj-grid").jqGrid("getGridParam", "selarrrow");
    //    //if (selRowIds.length > 0 && !this.allSelected)
    //    //$("#cb_" + this.gridData.alerts.gridString).click();
    //    for (var i = 0; i < gridData.data.length; i++) {
    //        $("#" + gridData.gridData.alerts.gridString)[0].p.data[i].cb = allSelected;
    //    }

    //    var array = [];
    //    if (allSelected) {
    //        for (var i = 0; i < gridData.data.length; i++) {
    //            array.push({ id: gridData.data[i].id, point: gridData.data[i].point });
    //        }
    //    } else {
    //        $("#" + gridData.gridData.alerts.gridString).jqGrid("resetSelection");
    //    }
    //    this.clientDataService.updateItem(gridData, array, "idsOfSelectedPoints");
    //    gridData.eventService.broadcast("selectAll", allSelected, gridData.idsOfSelectedPoints, type);
    //}

    //selectAll2(gridData, allSelected, gridComponent, gridType: string): void {
    //    $("#cb_" + gridData.gridString).click();
    //    var data = gridData.grid.jqGrid("getGridParam", "lastSelected");
    //    var selRowIds = $("#" + gridData.gridString).jqGrid("getGridParam", "selarrrow");
    //    //if (selRowIds.length > 0 && !this.allSelected)
    //    //$("#cb_" + this.gridData.alerts.gridString).click();
    //    for (var i = 0; i < data.length; i++) {
    //        $("#" + gridData.gridString)[0].p.data[i].cb = allSelected;
    //    }

    //    var array = [];
    //    if (allSelected) {
    //        for (var i = 0; i < data.length; i++) {
    //            array.push({ id: data[i].id, point: data[i].point });
    //        }
    //    } else {
    //        $("#" + gridData.gridString).jqGrid("resetSelection");
    //    }
    //    this.clientDataService.updateItem(gridComponent, array, "idsOfSelectedPoints");
    //    gridComponent.eventService.broadcast("selectAll", allSelected, gridComponent.idsOfSelectedPoints, gridType);
    //}

    selectIds(ids: any[], gridData: any, sort: boolean, type: string) {

        if (type == "Alarms") {
            var p = gridData.grid[0].p, data = p.data, item, $this = gridData.grid, index = p._index, rowid, selCount;

            for (var i = 0; i < data.length; i++) {
                data[i] = data[i].point.get("name");
            }
            for (var i = 0; i < ids.length; i++) {
                rowid = index[ids[i].id];
                item = ids[i].point.get("name");
                if ('cb' in item) {
                    item.cb = true;
                }
            }
        }
        /*if (rowid && data[rowid].cb != item.cb) {
            for (var i = 0; i < data.length; i++) {
                data[i] = gridData.masterData.array[data[i].point.get("index")];
            }
        }*/
        var col = gridData.grid.jqGrid("getGridParam", "sortname");
        var direction = gridData.grid.jqGrid("getGridParam", "sortorder");
        if (sort && ids.length > 0)
            gridData.grid.jqGrid("sortGrid", "cb", true, "desc");
        else if (sort)
            gridData.grid.jqGrid("resetSelection");
    }


    changeGridData(data: any[], col: any[], grid: any) {
        var page = grid.jqGrid("getGridParam", "page");
        var pageSize = grid.jqGrid("getGridParam", "rowNum");
        if (data.length <= pageSize * (page - 1))
            page = Math.floor((data.length - 1) / pageSize + 1);
        if (page < 1)
            page = 1;
        grid.jqGrid("clearGridData");
        grid.jqGrid("setGridParam", { data: data, colModel: col, page: page, rowNum: pageSize });
        grid.trigger("reloadGrid");
    }

    // NOTE: ----- DEPRECATED --------
    // Call changeGridData for all grid data refresh
    reloadGrid(data: any): any {
        $.jgrid.gridUnload("#" + data.gridString);
        this.loadGrid(data);
    }

    rowButtonClicked(options: any): void {

    }

    updateGridData(data: any[], dataToUpdate: any[], grid: any) {
        var indices = grid[0].p._index;
        for (var i = 0; i < dataToUpdate.length; i++) {
            data[indices[dataToUpdate[i].id]] = $.extend({}, true, dataToUpdate[i]);
        }
        this.changeGridData(data, grid.jqGrid("getGridParam", "colModel"), grid);
    }

    public removeGridItems(idsToRemove: any[], array: any[]) {
        for (var i = 0, j = 0; i < array.length; i++) {
            if (array[i].id == idsToRemove[j]) {
                array.splice(i, 1);
                j++;
                i--;
            } else {
                array[i].id = i + 1;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/grid.service.ts